import { RecurringTask, Task } from '@lmc/ts-common'
import * as types from '../common/types'

export const setTodosDate = (date: Date | string) => ({
  type: types.SET_CURRENT_DATE,
  date,
})

export const clearTodos = () => ({ type: types.CLEAR_TODOS })

export const setDailyTodos = (todos: Task[] ) => ({
  type: types.SET_DAILY_TODOS,
  todos,
})

export const setRecurringTodos = (recurringTodos: RecurringTask[]) => ({
  type: types.SET_RECURRING_TODOS,
  recurringTodos,
})
